import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse, List, ListItemButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ccyFormat } from '../../../../helpers/helper';
import SaleActions from './SaleActions';
import SaleTitle from './SaleTitle';

const DateGroupSection = ({
    date,
    saless,
    styleGroupByDate,
    getColorMoney,
    renderItemTitleWithOver,
    readonly,
    onReturnItem,
    onDelete,
    onReserve,
    onReturn,
    onPreviewTicket,
}) => {
    const [openDetailDate, setOpenDetailDate] = useState(false);

    return <Box display='flex' flexDirection='column' width='100%' paddingX={2} sx={styleGroupByDate}>
        <ListItemButton onClick={() => setOpenDetailDate(!openDetailDate)} sx={{ justifyContent: 'space-between', p: 0 }}>
            <Box display='flex' flexDirection='row' width='100%' alignItems='center'>
                <Typography display='flex' flexDirection='row' justifyContent='space-between' variant='subtitle2' width='100%' alignItems='center'>
                    <Box display='flex' component='span' flexDirection='row' alignItems='center'>
                        <Typography variant='inherit'><span>{date}</span></Typography>
                    </Box>
                </Typography>
                {openDetailDate ? <ExpandLess /> : <ExpandMore />}
            </Box>
        </ListItemButton>
        <List sx={{ width: '100%', padding: '0', margin: '0', ...styleGroupByDate }}>
            <Box sx={{ paddingX: 1 }}>
                <Box display='flex' flexDirection='column' width='100%'>
                    {saless.map(sale => (
                        <Collapse key={sale._id || `${date}-${sale.article?.id || sale.article?.name}-${sale.created_at}`} in={openDetailDate} timeout="auto" unmountOnExit sx={styleGroupByDate}>
                            <Box display='flex' paddingX={0} margin={0}>
                                <Typography display='flex' flexDirection='row' justifyContent='space-between' variant='inherit' width='100%' alignItems='center'>
                                    <Box display='flex' flexDirection='row'>
                                        <Box sx={{ background: getColorMoney(sale.payments), width: 2 }} />
                                        <Typography onClick={() => window.open(`${sale.article.images && sale.article.images[0]}`, '_blank')}>
                                            <SaleTitle sale={sale} renderItemTitleWithOver={renderItemTitleWithOver} />
                                        </Typography>
                                    </Box>
                                    <Box display='flex' flexDirection='row' alignItems='center'>
                                        <Typography ><span>{`$ ${ccyFormat(sale.prices_sold.sale_price * sale.quantity_sold)}`}</span></Typography>
                                        <SaleActions
                                            sale={sale}
                                            readonly={readonly}
                                            onReturnItem={onReturnItem}
                                            onDelete={() => onDelete(sale)}
                                            onReserve={() => onReserve(sale)}
                                            onReturn={() => onReturn(sale)}
                                            onPreviewTicket={onPreviewTicket}
                                            compact
                                        />
                                    </Box>
                                </Typography>
                            </Box>
                        </Collapse>
                    ))}
                </Box>
            </Box>
        </List>
    </Box>
}

export default DateGroupSection;
